<template>
  <div id="paginaImportaTracciatiContabilitaZip">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card File Upload:  -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Verifica Pagamenti</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
                <b-col xl="4" md="4" class="pt-1">
                  <ejs-button id="verifica2024button" cssClass="e-flat" @click.native="verifica(2024)">Verifica 2024</ejs-button>
                </b-col>
                <b-col xl="4" md="4" class="pt-1">
                  <ejs-button id="verifica2025button" cssClass="e-flat" @click.native="verifica(2025)">Verifica 2025</ejs-button>
                </b-col>
                <b-col xl="4" md="4" class="pt-1">
                  <ejs-button id="verifica2026button" cssClass="e-flat" @click.native="verifica(2026)">Verifica 2026</ejs-button>
                </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
import { CardPlugin, DropdownPlugin, LayoutPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs'
import { createElement } from '@syncfusion/ej2-base'

// use bootstrap-vue
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(LayoutPlugin)
// use Syncfusion
Vue.use(ButtonPlugin)
Vue.use(UploaderPlugin)

const apiVerificaPagamentiUrl = "/demo/api/costoproduzioni/verifica"

export default {
  data() {
    return {
      d: [],
    }
  },
  methods: {
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      })
    },
    verifica: function(a) {
      let datiDaInviare = {anno: a}

      useJwt.post(apiVerificaPagamentiUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
          this.makeToast("primary", "FAILURE", "Errore anno non selezionato")
      });
    }
  },
}
</script>
<style>
@import "~@syncfusion/ej2-base/styles/bootstrap.css";
@import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
.control-section {
  height: 100%;
  min-height: 200px;
}

button:has(> span.prova)
{
  display: none;
}
</style>
